import React, { Component } from 'react';
import Accordion from './Accordion';

import { desktopContentContainerPaperDivStyle, desktopSubjectdescriptionContainerStyle} from './styles/desktop';



export default class CourseList extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { subject, courseLevel } = this.props;

        return (
            <div id={this.props.subject.subject + '-page-container'} style={{}}>
                <div id={courseLevel + '-subject-description-container'} style={desktopSubjectdescriptionContainerStyle}>
                    {subject.subjectDescription}
                </div>
                <div id={this.props.subject.subject + 'container-paper-content-div'} style={desktopContentContainerPaperDivStyle}>
                    <Accordion deviceType={this.props.deviceType} courses={subject.courses} />
                </div>          
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/course/CourseList.js